/**
 * @fileoverview gRPC-Web generated client stub for dialerepb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.23.4
// source: external/dialer/dialer.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var xcommon_common_pb = require('../../xcommon/common_pb.js')

var xcommon_dialer_pb = require('../../xcommon/dialer_pb.js')

var xcommon_ticket_pb = require('../../xcommon/ticket_pb.js')
const proto = {};
proto.dialerepb = require('./dialer_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dialerepb.DialerServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dialerepb.DialerServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialReq,
 *   !proto.xcommon.DialResp>}
 */
const methodDescriptor_DialerService_MakeDial = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/MakeDial',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.DialReq,
  xcommon_dialer_pb.DialResp,
  /**
   * @param {!proto.xcommon.DialReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.DialResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.DialResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DialResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.makeDial =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/MakeDial',
      request,
      metadata || {},
      methodDescriptor_DialerService_MakeDial,
      callback);
};


/**
 * @param {!proto.xcommon.DialReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DialResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.makeDial =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/MakeDial',
      request,
      metadata || {},
      methodDescriptor_DialerService_MakeDial);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialInfoReq,
 *   !proto.xcommon.DialInfoResp>}
 */
const methodDescriptor_DialerService_DialInfo = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/DialInfo',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.DialInfoReq,
  xcommon_dialer_pb.DialInfoResp,
  /**
   * @param {!proto.xcommon.DialInfoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.DialInfoResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialInfoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.DialInfoResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DialInfoResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.dialInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/DialInfo',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialInfo,
      callback);
};


/**
 * @param {!proto.xcommon.DialInfoReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DialInfoResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.dialInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/DialInfo',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.KillCallReq,
 *   !proto.xcommon.DialResp>}
 */
const methodDescriptor_DialerService_KillDial = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/KillDial',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.KillCallReq,
  xcommon_dialer_pb.DialResp,
  /**
   * @param {!proto.xcommon.KillCallReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.DialResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.KillCallReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.DialResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DialResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.killDial =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/KillDial',
      request,
      metadata || {},
      methodDescriptor_DialerService_KillDial,
      callback);
};


/**
 * @param {!proto.xcommon.KillCallReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DialResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.killDial =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/KillDial',
      request,
      metadata || {},
      methodDescriptor_DialerService_KillDial);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ExtenStatusReq,
 *   !proto.xcommon.ExtenStatusResp>}
 */
const methodDescriptor_DialerService_ExtenStatus = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/ExtenStatus',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.ExtenStatusReq,
  xcommon_dialer_pb.ExtenStatusResp,
  /**
   * @param {!proto.xcommon.ExtenStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.ExtenStatusResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ExtenStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.ExtenStatusResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ExtenStatusResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.extenStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/ExtenStatus',
      request,
      metadata || {},
      methodDescriptor_DialerService_ExtenStatus,
      callback);
};


/**
 * @param {!proto.xcommon.ExtenStatusReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ExtenStatusResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.extenStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/ExtenStatus',
      request,
      metadata || {},
      methodDescriptor_DialerService_ExtenStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.StatusReq,
 *   !proto.xcommon.StatusResp>}
 */
const methodDescriptor_DialerService_Status = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/Status',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.StatusReq,
  xcommon_dialer_pb.StatusResp,
  /**
   * @param {!proto.xcommon.StatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.StatusResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.StatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.StatusResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.StatusResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.status =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/Status',
      request,
      metadata || {},
      methodDescriptor_DialerService_Status,
      callback);
};


/**
 * @param {!proto.xcommon.StatusReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.StatusResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.status =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/Status',
      request,
      metadata || {},
      methodDescriptor_DialerService_Status);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.UserDialInfoReq,
 *   !proto.xcommon.UserDialInfoResp>}
 */
const methodDescriptor_DialerService_UserDialInfo = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/UserDialInfo',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.UserDialInfoReq,
  xcommon_dialer_pb.UserDialInfoResp,
  /**
   * @param {!proto.xcommon.UserDialInfoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.UserDialInfoResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.UserDialInfoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.UserDialInfoResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.UserDialInfoResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.userDialInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/UserDialInfo',
      request,
      metadata || {},
      methodDescriptor_DialerService_UserDialInfo,
      callback);
};


/**
 * @param {!proto.xcommon.UserDialInfoReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.UserDialInfoResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.userDialInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/UserDialInfo',
      request,
      metadata || {},
      methodDescriptor_DialerService_UserDialInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetDialListParamReq,
 *   !proto.xcommon.GetDialListParamResp>}
 */
const methodDescriptor_DialerService_GetDialListParam = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/GetDialListParam',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.GetDialListParamReq,
  xcommon_dialer_pb.GetDialListParamResp,
  /**
   * @param {!proto.xcommon.GetDialListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.GetDialListParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetDialListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetDialListParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetDialListParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.getDialListParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/GetDialListParam',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetDialListParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetDialListParamReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetDialListParamResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.getDialListParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/GetDialListParam',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetDialListParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetDialListReq,
 *   !proto.xcommon.GetDialListResp>}
 */
const methodDescriptor_DialerService_GetDialList = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/GetDialList',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.GetDialListReq,
  xcommon_dialer_pb.GetDialListResp,
  /**
   * @param {!proto.xcommon.GetDialListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.GetDialListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetDialListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.GetDialListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetDialListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.getDialList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/GetDialList',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetDialList,
      callback);
};


/**
 * @param {!proto.xcommon.GetDialListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetDialListResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.getDialList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/GetDialList',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetDialList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.MediaReq,
 *   !proto.xcommon.MediaResp>}
 */
const methodDescriptor_DialerService_Media = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/Media',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.MediaReq,
  xcommon_dialer_pb.MediaResp,
  /**
   * @param {!proto.xcommon.MediaReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.MediaResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.MediaReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.MediaResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.MediaResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.media =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/Media',
      request,
      metadata || {},
      methodDescriptor_DialerService_Media,
      callback);
};


/**
 * @param {!proto.xcommon.MediaReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.MediaResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.media =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/Media',
      request,
      metadata || {},
      methodDescriptor_DialerService_Media);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.MediaV2Req,
 *   !proto.xcommon.MediaV2Resp>}
 */
const methodDescriptor_DialerService_MediaV2 = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/MediaV2',
  grpc.web.MethodType.SERVER_STREAMING,
  xcommon_dialer_pb.MediaV2Req,
  xcommon_dialer_pb.MediaV2Resp,
  /**
   * @param {!proto.xcommon.MediaV2Req} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.MediaV2Resp.deserializeBinary
);


/**
 * @param {!proto.xcommon.MediaV2Req} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.MediaV2Resp>}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.mediaV2 =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/dialerepb.DialerService/MediaV2',
      request,
      metadata || {},
      methodDescriptor_DialerService_MediaV2);
};


/**
 * @param {!proto.xcommon.MediaV2Req} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.MediaV2Resp>}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServicePromiseClient.prototype.mediaV2 =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/dialerepb.DialerService/MediaV2',
      request,
      metadata || {},
      methodDescriptor_DialerService_MediaV2);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialStatsReq,
 *   !proto.xcommon.DialStatsResp>}
 */
const methodDescriptor_DialerService_DialStats = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/DialStats',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.DialStatsReq,
  xcommon_dialer_pb.DialStatsResp,
  /**
   * @param {!proto.xcommon.DialStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.DialStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.DialStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DialStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.dialStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/DialStats',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialStats,
      callback);
};


/**
 * @param {!proto.xcommon.DialStatsReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DialStatsResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.dialStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/DialStats',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_DialerService_DialStatsExport = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/DialStatsExport',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.DialStatsReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.DialStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.dialStatsExport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/DialStatsExport',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialStatsExport,
      callback);
};


/**
 * @param {!proto.xcommon.DialStatsReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.dialStatsExport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/DialStatsExport',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialStatsExport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialStatsReq,
 *   !proto.xcommon.DialStatsResp>}
 */
const methodDescriptor_DialerService_DialHourlyStats = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/DialHourlyStats',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.DialStatsReq,
  xcommon_dialer_pb.DialStatsResp,
  /**
   * @param {!proto.xcommon.DialStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.DialStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.DialStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DialStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.dialHourlyStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/DialHourlyStats',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialHourlyStats,
      callback);
};


/**
 * @param {!proto.xcommon.DialStatsReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DialStatsResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.dialHourlyStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/DialHourlyStats',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialHourlyStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_DialerService_DialHourlyStatsExport = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/DialHourlyStatsExport',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.DialStatsReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.DialStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.dialHourlyStatsExport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/DialHourlyStatsExport',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialHourlyStatsExport,
      callback);
};


/**
 * @param {!proto.xcommon.DialStatsReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.dialHourlyStatsExport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/DialHourlyStatsExport',
      request,
      metadata || {},
      methodDescriptor_DialerService_DialHourlyStatsExport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CreateQualityInspectionVoipReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_DialerService_CreateQualityInspectionVoip = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/CreateQualityInspectionVoip',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.CreateQualityInspectionVoipReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.CreateQualityInspectionVoipReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.CreateQualityInspectionVoipReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.createQualityInspectionVoip =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/CreateQualityInspectionVoip',
      request,
      metadata || {},
      methodDescriptor_DialerService_CreateQualityInspectionVoip,
      callback);
};


/**
 * @param {!proto.xcommon.CreateQualityInspectionVoipReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.createQualityInspectionVoip =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/CreateQualityInspectionVoip',
      request,
      metadata || {},
      methodDescriptor_DialerService_CreateQualityInspectionVoip);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CallRecordReq,
 *   !proto.xcommon.CallRecordResp>}
 */
const methodDescriptor_DialerService_GetCallRecordList = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/GetCallRecordList',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.CallRecordReq,
  xcommon_dialer_pb.CallRecordResp,
  /**
   * @param {!proto.xcommon.CallRecordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.CallRecordResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CallRecordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CallRecordResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CallRecordResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.getCallRecordList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/GetCallRecordList',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetCallRecordList,
      callback);
};


/**
 * @param {!proto.xcommon.CallRecordReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CallRecordResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.getCallRecordList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/GetCallRecordList',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetCallRecordList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CallTextReq,
 *   !proto.xcommon.CallTextResp>}
 */
const methodDescriptor_DialerService_GetCallText = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/GetCallText',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.CallTextReq,
  xcommon_dialer_pb.CallTextResp,
  /**
   * @param {!proto.xcommon.CallTextReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.CallTextResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CallTextReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CallTextResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CallTextResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.getCallText =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/GetCallText',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetCallText,
      callback);
};


/**
 * @param {!proto.xcommon.CallTextReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CallTextResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.getCallText =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/GetCallText',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetCallText);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveCallTextReq,
 *   !proto.xcommon.SaveCallTextResp>}
 */
const methodDescriptor_DialerService_SaveCallText = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/SaveCallText',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.SaveCallTextReq,
  xcommon_dialer_pb.SaveCallTextResp,
  /**
   * @param {!proto.xcommon.SaveCallTextReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.SaveCallTextResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveCallTextReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.SaveCallTextResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveCallTextResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.saveCallText =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/SaveCallText',
      request,
      metadata || {},
      methodDescriptor_DialerService_SaveCallText,
      callback);
};


/**
 * @param {!proto.xcommon.SaveCallTextReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveCallTextResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.saveCallText =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/SaveCallText',
      request,
      metadata || {},
      methodDescriptor_DialerService_SaveCallText);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetDialListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_DialerService_ExportDialRecords = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/ExportDialRecords',
  grpc.web.MethodType.SERVER_STREAMING,
  xcommon_dialer_pb.GetDialListReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetDialListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetDialListReq} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.exportDialRecords =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/dialerepb.DialerService/ExportDialRecords',
      request,
      metadata || {},
      methodDescriptor_DialerService_ExportDialRecords);
};


/**
 * @param {!proto.xcommon.GetDialListReq} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServicePromiseClient.prototype.exportDialRecords =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/dialerepb.DialerService/ExportDialRecords',
      request,
      metadata || {},
      methodDescriptor_DialerService_ExportDialRecords);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.BatchAudioQualityReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_DialerService_BatchAudioQuality = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/BatchAudioQuality',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.BatchAudioQualityReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.BatchAudioQualityReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.BatchAudioQualityReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.batchAudioQuality =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/BatchAudioQuality',
      request,
      metadata || {},
      methodDescriptor_DialerService_BatchAudioQuality,
      callback);
};


/**
 * @param {!proto.xcommon.BatchAudioQualityReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.batchAudioQuality =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/BatchAudioQuality',
      request,
      metadata || {},
      methodDescriptor_DialerService_BatchAudioQuality);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.RobotCallRecordListReq,
 *   !proto.xcommon.RobotCallRecordListResp>}
 */
const methodDescriptor_DialerService_GetRobotCallRecordList = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/GetRobotCallRecordList',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.RobotCallRecordListReq,
  xcommon_dialer_pb.RobotCallRecordListResp,
  /**
   * @param {!proto.xcommon.RobotCallRecordListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.RobotCallRecordListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.RobotCallRecordListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.RobotCallRecordListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.RobotCallRecordListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.getRobotCallRecordList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/GetRobotCallRecordList',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetRobotCallRecordList,
      callback);
};


/**
 * @param {!proto.xcommon.RobotCallRecordListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.RobotCallRecordListResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.getRobotCallRecordList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/GetRobotCallRecordList',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetRobotCallRecordList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.RobotCallRecordListReq,
 *   !proto.xcommon.WhetherRobotCallListResp>}
 */
const methodDescriptor_DialerService_GetWhetherRobotCallList = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/GetWhetherRobotCallList',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.RobotCallRecordListReq,
  xcommon_dialer_pb.WhetherRobotCallListResp,
  /**
   * @param {!proto.xcommon.RobotCallRecordListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.WhetherRobotCallListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.RobotCallRecordListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.WhetherRobotCallListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WhetherRobotCallListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.getWhetherRobotCallList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/GetWhetherRobotCallList',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetWhetherRobotCallList,
      callback);
};


/**
 * @param {!proto.xcommon.RobotCallRecordListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WhetherRobotCallListResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.getWhetherRobotCallList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/GetWhetherRobotCallList',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetWhetherRobotCallList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.RobotCallRecordReq,
 *   !proto.xcommon.RobotCallRecordResp>}
 */
const methodDescriptor_DialerService_GetRobotCallRecord = new grpc.web.MethodDescriptor(
  '/dialerepb.DialerService/GetRobotCallRecord',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.RobotCallRecordReq,
  xcommon_dialer_pb.RobotCallRecordResp,
  /**
   * @param {!proto.xcommon.RobotCallRecordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_dialer_pb.RobotCallRecordResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.RobotCallRecordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.RobotCallRecordResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.RobotCallRecordResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.DialerServiceClient.prototype.getRobotCallRecord =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.DialerService/GetRobotCallRecord',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetRobotCallRecord,
      callback);
};


/**
 * @param {!proto.xcommon.RobotCallRecordReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.RobotCallRecordResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.DialerServicePromiseClient.prototype.getRobotCallRecord =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.DialerService/GetRobotCallRecord',
      request,
      metadata || {},
      methodDescriptor_DialerService_GetRobotCallRecord);
};


module.exports = proto.dialerepb;

